import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_SERVER2_URL}/graphql`,
  credentials: 'same-origin',
});

const searchClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

export default searchClient;